module.exports = __webpack_public_path__ + "static/media/gold.7cd9ef52.png";